// A conta pura por trás de useAlturaLinhaVideo, sem React, para os testes
// correrem em Node. Ver useAlturaLinhaVideo.js para o porquê.

export const ALTURA_MINIMA_LINHA = 140;
// Até à primeira medição (ou se ela falhar): o maior entre o valor antigo e o
// ecrã inteiro menos ~300px de cabeçalho e ~230px de barra de baixo.
export const ALTURA_DE_RECURSO = 'max(min(37.5vw, 45vh), calc(100vh - 530px))';
export const FOLGA_LINHA = 8;

// Quanto sobra para a linha de vídeo: a altura do ecrã menos o que está por
// cima (topo da linha) e por baixo (chat, botões, barra fixa), com uma folga.
// Nunca abaixo do mínimo — em paisagem num telemóvel pequeno prefere-se
// uma linha baixa a uma linha de altura zero.
export function calcularAlturaLivre({ alturaEcra, topo, abaixo, folga = FOLGA_LINHA, minimo = ALTURA_MINIMA_LINHA }) {
  const livre = Math.floor(alturaEcra - topo - abaixo - folga);
  if (!Number.isFinite(livre)) return minimo;
  return Math.max(minimo, livre);
}
